import { ImageKit, Typography } from "@aph/ui-lib-humanx";
import React from "react";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import styles from "./ProfileBabyOnboardBanner.module.scss";

interface ProfileBabyOnboardBannerProps {
  btnClick?: () => void;
  className?: string;
}

const ProfileBabyOnboardBanner: React.FC<ProfileBabyOnboardBannerProps> = (props) => {
  const { btnClick, className = "" } = props;

  return (
    <div className={`${styles.bannerRoot} ${className}`}>
      <div className={styles.leftBx}>
        <Typography className={styles.title}>
          Personalise your <strong>pregnancy and parenting</strong> journey with us
        </Typography>
        <button color="tertiarybaby" className={styles.btn} onClick={btnClick}>
          Onboard Now
        </button>
      </div>
      <div className={styles.imgBx}>
        <ImageKit
          src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/profile_onboarding.png`}
          alt="onboard now image"
          height={100}
          width={100}
        />
      </div>
    </div>
  );
};

export default ProfileBabyOnboardBanner;
